/**
 * Production photo updates — Step 12/13 mock data.
 *
 * Each update: image (CSS-painted placeholder, since we don't ship real
 * factory photos), AI-generated caption + quality assessment, ts, sender.
 */

const isoDaysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

export const PRODUCTION_UPDATES = {
  'demo-radios': [],

  'demo-furniture': [
    {
      id: 'p1',
      ts: isoDaysAgo(15),
      sender: 'ErgoMax (WhatsApp)',
      caption: 'Frame welding line — Day 7 of production',
      placeholder: 'frame-welding',
      tone: '#475569',
      ai: {
        summary: 'Frame production line operating normally. Visible: 3 welders working on lower-frame cross-members. No alignment issues detected.',
        flags: [],
        confidence: 0.92,
      },
    },
    {
      id: 'p2',
      ts: isoDaysAgo(8),
      sender: 'ErgoMax (WhatsApp)',
      caption: 'Worksurface QC — Day 14',
      placeholder: 'worksurface-qc',
      tone: '#a16207',
      ai: {
        summary: 'Worksurface QC underway. Edge-banding consistent, no chipping visible on the 12 units shown. Color match is uniform.',
        flags: [],
        confidence: 0.88,
      },
    },
    {
      id: 'p3',
      ts: isoDaysAgo(2),
      sender: 'ErgoMax (WhatsApp)',
      caption: 'Task chair assembly — Day 20',
      placeholder: 'chair-assembly',
      tone: '#1e3a8a',
      ai: {
        summary: 'Task chairs in final assembly. Mesh-back tension uniform across 8 visible units. Lumbar adjustment levers correctly oriented.',
        flags: [
          { severity: 'info', text: 'One chair (foreground left) shows armrest at slight angle — likely fine, recommend QC verification at Day 30 inspection.' },
        ],
        confidence: 0.81,
      },
    },
  ],

  'demo-streetlights': [
    {
      id: 'p1',
      ts: isoDaysAgo(40),
      sender: 'Brightway (WhatsApp)',
      caption: 'Final QC + packaging — Day 35',
      placeholder: 'qc-packaging',
      tone: '#0e7490',
      ai: {
        summary: '1100 luminaires palletized for shipping. NEMA 7-pin receptacles correctly capped. DLC labels applied per spec.',
        flags: [],
        confidence: 0.94,
      },
    },
  ],
};
